import type { IExtractRouteParamMap } from "@/routes";
import { createPaths } from "@/routes/utils";

const baseRoute = `/user-management`;

export const usersRoutesObj = {
  list: baseRoute,
  create: `${baseRoute}/:role/create`,
  edit: `${baseRoute}/:role/edit/:userId`,
  view: `${baseRoute}/:role/view/:userId`,
} as const;

export type IUsersRouteParams = IExtractRouteParamMap<typeof usersRoutesObj>;

export const usersPath = createPaths<typeof usersRoutesObj, IUsersRouteParams>(
  usersRoutesObj,
);
